import { Config } from 'config';

export const getBrandingLogo = () => `/branding/${Config.brandingId}/logo.png`;
